import React, { useEffect } from 'react';
import Modal from 'react-modal';
import CreateNewProduct from '../Sidebar/ProductsAndStyle/CreateNewProduct';

Modal.setAppElement('#root'); // Ensure accessibility

const ProductModal = ({ isOpen, onRequestClose, fetchProducts, setMyProducts, setCreditsAvailable }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    // Cleanup function to reset styles when component unmounts
    return () => {
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    };
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Create Product Modal"
      className="max-w-4xl w-full mx-auto my-5 rounded-lg p-6 relative bg-white shadow-xl"
      overlayClassName="fixed inset-0 bg-black bg-opacity-90 backdrop-blur-2xl flex items-center justify-center z-50"
      style={{
        content: {
          maxHeight: '90vh',
          overflowY: 'auto'
        }
      }}
    >
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">Create New Product</h2>
        <button
          onClick={onRequestClose}
          className="text-gray-700 hover:text-gray-700 transition-colors duration-200"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="border-t border-gray-200 pt-6">
        <CreateNewProduct onRequestClose={onRequestClose} fetchProducts={fetchProducts} setMyProducts={setMyProducts} setCreditsAvailable={setCreditsAvailable}/>
      </div>
    </Modal>
  );
};

export default ProductModal;
